module.exports = __webpack_public_path__ + "static/media/icon-font-numbered-list.f09ca23e.svg";